import React from 'react';
import { Link, LinkProps } from 'react-router-dom';


export function MenuLink(props: LinkProps) {
  return <Link
    style={{
      color: '#16181b',
      fontSize: '13px',
      width: '100%',
      textDecoration: 'none',
    }}
    {...props}
  />
}
